/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// React
import React from "react";
import Typography from "@mui/material/Typography";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';

function NumberedHeading({ number, title, instructions, required }) {

  return (
    <List className="p-0">
      <ListItem alignItems="flex-start" className="p-0 mt-16">
        <ListItemAvatar className="mr-8 mt-0" sx={{ minWidth: 24}}>
          <Avatar
            sx={{ width: 24, height: 24, color: '#6b7280', borderColor: '#6b7280' }}
            className="text-sm font-semibold m-0 border-1 bg-transparent"
          >
            {number}
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          className="m-0"
          primary={
            <Typography variant="subtitle2" className="font-semibold">
              {title} {required && <span className="text-red-500">*</span>}
            </Typography>
          }
          secondary={
            <>
              {instructions}
            </>
          }
        />
      </ListItem>
    </List>
  );
}

export default NumberedHeading;
